import React from "react";
import NumberFormat from "react-number-format";

export default function (field) {
  const { className } = field;

  return (
    <div>
      <div className="position-r">
        <NumberFormat
          aria-label={field["aria-label"]}
          className={className}
          thousandSeparator={true}
          decimalScale={2}
          allowNegative={false}
          displayType="input"
          type="text"
          onValueChange={field.onValueChange}
          disabled={field.selectedCausesCount >= 1 ? true : false}
          {...field.input}
        />
        <i className="donation-amount--dollar">{field.currencySymbol}</i>
      </div>
      {field.meta.touched && field.meta.error && (
        <div className="donation-error">{field.meta.error}</div>
      )}
      {field.selectedCausesCount >= 1 ? "edit amount below" : ""}
    </div>
  );
}
